import { AlertTriangle, CheckCircle2, Mail, ShieldCheck, UserCircle2 } from 'lucide-react';
import { Button } from './ui/button';

export const AccountStatusPanel = ({
  user,
  onCompleteProfile,
  onVerifyEmail,
  onOpenSecurity,
}) => {
  const isProfileComplete = Boolean(user?.profile_completed);
  const isEmailVerified = Boolean(user?.email_verified);
  const isReady = isProfileComplete && isEmailVerified;

  return (
    <div className="bg-[#0D121D] border-b border-white/10 px-4 py-4" data-testid="account-status-panel">
      <div className="max-w-2xl mx-auto">
        <div className="mb-3 flex items-center gap-2">
          <ShieldCheck className="h-5 w-5 text-[#BBFF00]" />
          <h3 className="font-semibold text-slate-100">Estado de tu cuenta jugador</h3>
        </div>

        <div className="space-y-2 text-sm">
          <div className="flex items-center justify-between rounded-lg bg-[#131B2A] border border-white/5 px-3 py-2" data-testid="account-status-profile-row">
            <div className="flex items-center gap-2">
              <UserCircle2 className="h-4 w-4 text-slate-500" />
              <span className="text-slate-300">Perfil (nombre + apellido + contraseña)</span>
            </div>
            {isProfileComplete ? (
              <span className="inline-flex items-center gap-1 text-[#BBFF00]"><CheckCircle2 className="h-4 w-4" /> Completo</span>
            ) : (
              <span className="inline-flex items-center gap-1 text-amber-400"><AlertTriangle className="h-4 w-4" /> Pendiente</span>
            )}
          </div>

          <div className="flex items-center justify-between rounded-lg bg-[#131B2A] border border-white/5 px-3 py-2" data-testid="account-status-email-row">
            <div className="flex items-center gap-2">
              <Mail className="h-4 w-4 text-slate-500" />
              <span className="text-slate-300">Correo verificado (para descargar/compartir)</span>
            </div>
            {isEmailVerified ? (
              <span className="inline-flex items-center gap-1 text-[#BBFF00]"><CheckCircle2 className="h-4 w-4" /> Verificado</span>
            ) : (
              <span className="inline-flex items-center gap-1 text-amber-400"><AlertTriangle className="h-4 w-4" /> Pendiente</span>
            )}
          </div>
        </div>

        <Button 
          className="mt-4 w-full bg-[#BBFF00] hover:bg-[#A2DC00] text-[#070A0F] font-bold shadow-[0_0_20px_rgba(187,255,0,0.25)]" 
          onClick={onOpenSecurity} 
          data-testid="account-status-open-security-button"
        >
          Seguridad
        </Button>

        <p className="mt-3 text-xs text-slate-500" data-testid="account-status-summary-text">
          {isReady
            ? 'Cuenta lista: ya puedes reproducir, descargar y compartir tus videos.'
            : 'Completa los pasos pendientes para desbloquear todas las funciones de tus replays.'}
        </p>
      </div>
    </div>
  );
};
